import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_profile: {},
    user_login: false,
    rwdType: 'desktop',
    alert: {
      show: false,
      status: '',
    },
    user_Id: null,
    /**
     * healthBackground: 首次諮詢時填寫的健康背景資料暫存
     * 
     * 使用場景:
     * 1. 病患首次使用 (is_first_question = true)
     * 2. 在 HealthBackground.vue 填寫資料後點擊「下一步」
     * 3. 資料暫存到此 state,即使關閉彈窗也不會遺失
     * 4. 在 AskPopupF.vue 送出成功後,連同此資料一併傳送到後端
     * 5. 後端更新成功後清空此 state
     * 
     * 資料結構:
     * - birth: 出生日期 (YYYY-MM-DD 格式)
     * - gender: 性別 (Male/Female/Other)
     * - major_health_problems: 主要健康問題 (文字,含中文翻譯 #中文)
     * - medicines: 服用藥物 (文字,含中文翻譯 #中文)
     * - allergies: 過敏史 (文字,含中文翻譯 #中文)
     * - lifestyle_smoking: 抽菸習慣 (Yes#是/No#否/Sometimes#有時候)
     * - lifestyle_alcohol: 飲酒習慣 (Yes#是/No#否/Sometimes#有時候)
     */
    healthBackground: {
      birth: '',
      gender: '',
      major_health_problems: '',
      medicines: '',
      allergies: '',
      lifestyle_smoking: '',
      lifestyle_alcohol: ''
    }
  },
  getters: {
    exportUserProfile(st) {
      // console.log('exportUserProfile: ', st.user_profile);
      return st.user_profile;
    },
    exportUserId(st) {
      // console.log('exportUserId: ', st.user_profile.id);
      return st.user_Id;
    },
    exportChatRoom(st) { 
      return st.chat_room;
    },
    exportUserLogin(st) {
      return st.user_login;
    },
    exportAlert(st) {
      return st.alert;
    },
    exportRwdType(st) {
      return st.rwdType;
    },
    /**
     * 匯出健康背景資料
     * 用於 HealthBackground.vue 和 AskPopupF.vue 讀取暫存的資料
     */
    exportHealthBackground(st) {
      return st.healthBackground;
    }
  },
  mutations: {
    UPDATE_USER_PROFILE(st, payload) {
      st.user_profile = {
        ...payload,
        user_lang: payload.user_lang || '',
        is_first_question: payload.is_first_question !== undefined ? payload.is_first_question : true
      };
    },
    UPDATE_USER_ID(st, payload) {
      // if (st.user_profile) {
      //   st.user_profile.id = payload;
      // }
      st.user_Id = payload;
      // console.log('UPDATE_USER_ID: ', st.user_profile.id);
    },
    UPDATE_CHAT_ROOM(st, payload) {
      st.chat_room = payload;
    },
    UPDATE_USER_LOGIN(st, payload) {
      st.user_login = payload;
    },
    UPDATE_ALERT(st, payload) {
      st.alert = payload;
    },
    SET_USER_ID(state, userId) {
      state.user_Id = userId;
    },
    SET_RWD_TYPE(state, payload) {
      state.rwdType = payload;
    },
    /**
     * 更新健康背景資料到 Vuex store
     * 
     * 呼叫時機: HealthBackground.vue 點擊「下一步」按鈕
     * 
     * @param {Object} payload - 健康背景資料物件
     * @param {string} payload.birth - 出生日期 (YYYY-MM-DD)
     * @param {string} payload.gender - 性別 (Male/Female/Other)
     * @param {string} payload.major_health_problems - 主要健康問題
     * @param {string} payload.medicines - 服用藥物
     * @param {string} payload.allergies - 過敏史
     * @param {string} payload.lifestyle_smoking - 抽菸習慣 (Yes#是/No#否/Sometimes#有時候)
     * @param {string} payload.lifestyle_alcohol - 飲酒習慣 (Yes#是/No#否/Sometimes#有時候)
     * 
     * 注意: 此 mutation 只更新 Vuex state,不會呼叫後端 API
     *      真正的後端更新發生在 AskPopupF.vue 送出成功時
     */
    UPDATE_HEALTH_BACKGROUND(state, payload) {
      state.healthBackground = {
        ...state.healthBackground,
        ...payload
      };
    },
    /**
     * 清空健康背景資料
     * 
     * 呼叫時機: AskPopupF.vue 送出成功且後端更新成功後
     * 
     * 目的: 避免下次諮詢時誤用舊資料
     */
    CLEAR_HEALTH_BACKGROUND(state) {
      state.healthBackground = {
        birth: '',
        gender: '',
        major_health_problems: '',
        medicines: '',
        allergies: '',
        lifestyle_smoking: '',
        lifestyle_alcohol: ''
      };
    }
  },
  actions: {
    updateUserId({ commit }, userId) {
      commit('SET_USER_ID', userId);
    }
  },
  modules: {
  }
})
